import { apiService } from "./apiService";
import { endpoints } from "@/config/endpoints";

export default {
  getCompanyKeywords(params = {}) {
    return apiService.get(endpoints.keywords.company, { params });
  },

  postCompanyKeyword(payload) {
    return apiService.post(endpoints.keywords.company, payload);
  },

  deleteCompanyKeyword(keywordId) {
    return apiService.delete(endpoints.keywords.companyDelete(keywordId));
  }

  // TODO: facility and group scope logic
  // getBusinessAddressKeywords(businessAddressId) {
  //   return apiService.get(
  //     `${endpoints.keywords.address}?gmb_address_id=${businessAddressId}`
  //   );
  // },

  // postBusinessAddressKeyword(payload) {
  //   return apiService.post(endpoints.keywords.address, payload);
  // },

  // deleteBusinessAddressKeyword(keyword) {
  //   return apiService.delete(endpoints.keywords.address, keyword);
  // },
};
